import { HttpErrorResponse } from "@angular/common/http";

import { FundWithRelated } from "@models/fund-with-related.model";
import { NavPeriod } from "@models/nav-period.model";
import { TradeMoment } from "@models/trade-moment-model";
import { Yieldu } from "@models/yieldu-model";
import { createReducer, on } from "@ngrx/store";

import * as TradingActions from "../store/trading.actions";

export const TRADING_FEATURE_KEY = "trading";

export interface TradingState {
  loading: boolean;
  error: HttpErrorResponse | null;
  fundList: Array<FundWithRelated>;
  navHistory: Array<NavPeriod>;
  yielduList: Array<Yieldu>;
  tradeMoment: TradeMoment | undefined;
  transactions: number | undefined;
  tradeStatus: boolean;
  tradeSectionLoading: boolean;
}

const initialState: TradingState = {
  loading: false,
  error: null,
  fundList: [],
  navHistory: [],
  yielduList: [],
  tradeMoment: undefined,
  transactions: undefined,
  tradeStatus: false,
  tradeSectionLoading: false,
};

export const TRADING_REDUCER = createReducer(
  initialState,
  on(
    TradingActions.SET_TRADING_LOADING_STATUS,
    (state: TradingState, action: { loading: boolean }): TradingState => {
      return {
        ...state,
        loading: action.loading,
      };
    }
  ),
  on(
    TradingActions.SET_TRADING_ERROR,
    (
      state: TradingState,
      action: { error: HttpErrorResponse }
    ): TradingState => {
      return {
        ...state,
        error: action.error,
      };
    }
  ),
  on(
    TradingActions.SET_FUND_LIST,
    (
      state: TradingState,
      action: {
        fundList: Array<FundWithRelated>;
      }
    ): TradingState => {
      return {
        ...state,
        fundList: action.fundList,
      };
    }
  ),
  on(
    TradingActions.SET_LATEST_TRADING,
    (
      state: TradingState,
      action: { tradeMoment: TradeMoment }
    ): TradingState => {
      return {
        ...state,
        tradeMoment: action.tradeMoment,
      };
    }
  ),
  on(
    TradingActions.SET_TRANSACTIONS_COUNT,
    (state: TradingState, action: { transactions: number }): TradingState => {
      return {
        ...state,
        transactions: action.transactions,
      };
    }
  ),
  on(
    TradingActions.SET_NAV_HISTORY,
    (state: TradingState, action: { navTable: any }): TradingState => {
      //TODO @Adrian add type
      return {
        ...state,
        navHistory: action.navTable,
      };
    }
  ),
  on(
    TradingActions.SET_YIELDU_EFFICIENCY,
    (
      state: TradingState,
      action: { yielduList: Array<Yieldu> }
    ): TradingState => {
      return {
        ...state,
        yielduList: action.yielduList,
      };
    }
  ),
  on(
    TradingActions.SET_TRADE_STATUS,
    (state: TradingState, action: { tradeStatus: boolean }): TradingState => {
      return {
        ...state,
        tradeStatus: action.tradeStatus,
      };
    }
  ),
  on(
    TradingActions.SET_TRADING_MOMENT_LOADING_STATUS,
    (
      state: TradingState,
      action: { tradeSectionLoading: boolean }
    ): TradingState => {
      return {
        ...state,
        tradeSectionLoading: action.tradeSectionLoading,
      };
    }
  )
);
